import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { getAuth } from "firebase/auth";
import { useModal } from "../../context/ModalContext";
import { useRouter } from "next/router";
import { toast } from "react-hot-toast";
import styles from "../../styles/Model.module.css";
import { useState } from "react";
import {
  capitalizeFirstLetter,
  getDisplayName,
  rgbDataURL,
} from "../../utils/tools";
import Image from "next/image";
import { Button } from "@jammable/ui-core";
import { Input, TextArea } from "@jammable/ui-components/Forms";
import { Spinner } from "@jammable/ui-components/Loader";

// ...

const ReportModal = ({ item, type }) => {
  const validationSchema = yup.object().shape({
    subject: yup
      .string()
      .required("Subject is required")
      .max(40, "40 characters maximum."),
    description: yup
      .string()
      .required("Description is required")
      .max(1000, "1000 characters maximum."),
  });
  const { closeModal } = useModal();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formik = useFormik({
    initialValues: {
      subject: "",
      description: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();
      axios
        .post(
          `/api/other/createReport`,
          {
            type: type,
            description: values.description,
            subject: values.subject,
            itemInfo: item?._id,
          },
          {
            headers: { Authorization: token },
          },
        )
        .then((res) => {
          toast.success(`Report submitted!`);
          closeModal("report-modal");
        })

        .catch((err) => {
          toast.error(`Error reporting conversion. Please try again!`);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });
  return (
    <div className="vertical-flex-10">
      <div style={{ marginBottom: 0 }} className="tw-text-xl tw-font-black">
        Report {capitalizeFirstLetter(type)}
      </div>

      <form
        onChange={() => {
          setError(null);
        }}
        className="vertical-flex-15"
        onSubmit={formik.handleSubmit}
      >
        {error && <div className="error-message">{error}</div>}
        <div className="tw-flex tw-flex-col tw-gap-2">
          <Input
            fullWidth
            color="primary"
            bordered
            placeholder="The subject of your report..."
            className="tw-w-full"
            name="subject"
            value={formik.values.subject}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.subject && !!formik.errors.subject}
            label="Subject"
          />
          {formik.touched.subject && formik.errors.subject && (
            <div className="error-text">{formik.errors.subject}</div>
          )}
          <TextArea
            fullWidth
            color="primary"
            bordered
            placeholder="Please provide a detailed description of the reason of your report..."
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Description"
            className="tw-w-full"
            error={formik.touched.description && !!formik.errors.description}
          />
          {formik.touched.description && formik.errors.description && (
            <div className="error-text">{formik.errors.description}</div>
          )}
        </div>
        <Button disabled={loading} type="submit" className="tw-rounded-full">
          {loading ? (
            <Spinner size={4} className="tw-border-white" />
          ) : (
            "Submit Report"
          )}
        </Button>
      </form>
    </div>
  );
};

export default ReportModal;
